import { useRef, useState } from "react"

export const useGlobalStates = () => {
    
    //para el formulario
    const [showForm, setShowForm ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')

    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [showTypeForm, setshowTypeForm] = useState('None')

    // para el steper
    const [stepApplilication, setStepApplilication] = useState(0)

    const calendarRef = useRef(null);

    const [ backgroundCode, setBackgroundCode ] = useState({
        vehicle: {
            pagoVehiculoAtrasado: '#ab2b2b',
            pagoVehiculoNormal: '#0a8ab8',
            pagoVehiculoVerde: '#2bab2b',
            RenovacionGPS: '#F48836',
            RenovacionSeguro: '#F44336',
        },
        leases: {
            pagoAlquilerAtrasado: '#ab2b2b',
            pagoAlquilerNormal: '#5c0474',
        }
    })


    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        stepApplilication, setStepApplilication,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        showTypeForm, setshowTypeForm,
        calendarRef,
        backgroundCode, setBackgroundCode
    })
}